import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { alertActions } from "../redux/AlertController";
import useLogout from "./useLogout";

export const useSettings = () => {
    const [content, setContent] = useState({ description: '', terms: '', generalInfo: '', requiredDocuments: [], confirmationCheckboxes: [], maxApplications: 1500, registrationOpen: true, existingApplicantsOnly: false, cities: [], supportPhone: '', facebookUrl: '', websiteUrl: '' });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const dispatch = useDispatch();
    const user = useSelector(state => state.userController.user);
    const navigate = useNavigate();
    const { logout } = useLogout();

    const fetchContent = async () => {
        setIsLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/settings`, {
                headers: {
                    'Authorization': `Bearer ${user?.token}`
                }
            });
            const json = await res.json();

            if (res.status === 401) {
                logout();
            } else if (!res.ok) {
                dispatch(alertActions.showAlert({ msg: json.message, type: 'error' }));
            } else {
                setContent(json);
            }
        } catch (err) {
            dispatch(alertActions.showAlert({ msg: err.message, type: 'error' }));
        }
        setIsLoading(false);
    };

    const saveContent = async (updated) => {
        setIsSaving(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/settings`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user?.token}`
                },
                body: JSON.stringify(updated)
            });
            const json = await res.json();

            if (res.status === 401) {
                logout();
            } else if (!res.ok) {
                dispatch(alertActions.showAlert({ msg: json.message, type: 'error' }));
            } else {
                setContent(json);
                dispatch(alertActions.showAlert({ msg: 'تم حفظ التغييرات بنجاح', type: 'success' }));
            }
        } catch (err) {
            dispatch(alertActions.showAlert({ msg: err.message, type: 'error' }));
        }
        setIsSaving(false);
    };

    useEffect(() => {
        if (!user) {
            navigate('/login');
        } else {
            fetchContent();
        }
    }, [user]);

    return { content, isLoading, isSaving, saveContent };
};
